var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C12.4792 4.5 12.55 5.18333 12.1483 5.445C10.9312 6.23433 10.0518 7.44888 9.68181 8.85162C9.31184 10.2544 9.47783 11.7446 10.1474 13.0316C10.8169 14.3185 11.942 15.3098 13.303 15.812C14.664 16.3141 16.1633 16.2912 17.5083 15.7475C17.9075 15.5875 18.3608 15.9983 18.1117 16.3483C17.3659 17.3964 16.363 18.2351 15.1996 18.7837C14.0361 19.3323 12.751 19.5724 11.4679 19.481C10.1849 19.3896 8.94684 18.9698 7.87287 18.2618C6.79889 17.5538 5.92507 16.5814 5.33537 15.4382C4.74568 14.295 4.45993 13.0193 4.50558 11.7338C4.55124 10.4483 4.92676 9.19609 5.59608 8.09759C6.26539 6.99909 7.20599 6.0912 8.32748 5.46117C9.44897 4.83114 10.7137 4.50015 12 4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkToggle);
export default __webpack_public_path__ + "static/media/dark-toggle.90e7b1dc5b31197f3725781b9bc334ba.svg";
export { ForwardRef as ReactComponent };